<!--
 * @Descripttion: 登录弹窗
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-09 15:21:56
 * @LastEditors: hayuu
 * @LastEditTime: 2025-04-09 13:38:57
-->
<template>
  <div class="login_mask">
    <div class="login_dia">
      <img src="@/assets/images/logintc_close_btn.png" alt="" class="close" @click="handleClose">
      <div class="login_dia_left">
        <img src="@/assets/images/login_left_bg.png" alt="">
        <div class="title_box">
          <div class="title_box_left">
            <img src="@/assets/images/login_logo_img.png" alt="">
          </div>
          <div class="title_box_right">
            <h4>山西政务服务平台</h4>
            <p>统一身份认证登录</p>
          </div>
        </div>
      </div>
      <div class="login_dia_right">
        <div class="login_dia_right_nav">
          <div class="login_dia_right_nav_item" :class="{ active: activeNav == index }" v-for="item, index in navList"
            :key="index" @click="handleNav(index)">
            {{ item }}
          </div>
        </div>

        <div class="login_dia_right_form_content">
          <div class="item" :class="{ activeTab: loginMode == 0 }" @click="handleMode(0)">手机号登录</div>
          <div class="item" :class="{ activeTab: loginMode == 1 }" @click="handleMode(1)">账号密码登录</div>
        </div>

        <div class="login_dia_right_form">
          <el-form label-position="top" label-width="80px" :model="loginForm" :rules="rules" ref="loginForm">
            <!-- 账号输入表单项 -->
            <el-form-item :label="loginMode == 0 ? '手机号' : '账号'" prop="loginNo">
              <el-input data-mode="num" v-model="loginForm.loginNo"
                :placeholder="loginMode == 0 ? '请输入手机号' : '请输入手机号/用户名/身份证号'" @keyup.enter.native="login">
                <img src="@/assets/images/login_phone_icon.png" alt="" slot="prefix" class="input_img">
              </el-input>
            </el-form-item>
            <!-- 验证码输入表单项 -->
            <el-form-item label="验证码" prop="vcode">
              <el-input data-mode="en" v-model="loginForm.vcode" placeholder="请输入验证码" maxlength="4"
                @keyup.enter.native="login">
                <img src="@/assets/images/login_pic_icon.png" alt="" slot="prefix" class="input_img">
                <div slot="suffix">
                  <img :src="codeUrl" @click="getCode" style="height: 55px" />
                </div>
              </el-input>
            </el-form-item>
            <!-- 验证码输入表单项 -->
            <el-form-item label="手机验证码" v-if="loginMode == 0" prop="smscode">
              <el-input data-mode="num" v-model="loginForm.smscode" placeholder="请输入手机验证码" @keyup.enter.native="login">
                <img src="@/assets/images/login_code_icon.png" alt="" slot="prefix" class="input_img">
                <!-- 验证码发送 -->
                <div class="vcode" :class="waitTime == 0 ? '' : 'disabled'" slot="suffix"
                  @click="waitTime == 0 ? handleCode() : ''" element-loading-spinner="el-icon-loading"
                  v-loading="codeLoading">
                  {{ waitTime == 0 ? "发送验证码" : waitTime + "s" }}
                </div>
              </el-input>
            </el-form-item>
            <!-- 密码输入表单项 -->
            <el-form-item label="密码" v-else prop="password">
              <el-input data-mode="en" v-model="loginForm.password" :type="passwordOpen ? 'text' : 'password'"
                placeholder="请输入密码" @keyup.enter.native="login">
                <img src="@/assets/images/login_key_icon.png" alt="" slot="prefix" class="input_img">
                <!-- 密码显示/隐藏切换 -->
                <div class="login_password" slot="suffix">
                  <img v-show="passwordOpen" src="@/assets/images/login_open_btn.png" alt=""
                    @click="passwordOpen = false" />
                  <img v-show="!passwordOpen" src="@/assets/images/login_close_btn.png" alt=""
                    @click="passwordOpen = true" />
                </div>
              </el-input>
            </el-form-item>
            <!-- 登录按钮 -->
            <!-- <el-form-item>
                            <el-button :type="(isLoginBtnEnabled && 'primary') || 'info'" :disabled="!isLoginBtnEnabled" element-loading-spinner="el-icon-loading" v-loading="btnLoading" @click="login">立即登录</el-button>
                        </el-form-item> -->
            <div class="btn" :class="{ disabled: !isLoginBtnEnabled }" @click="isLoginBtnEnabled ? login() : ''"
              element-loading-spinner="el-icon-loading" v-loading="btnLoading">
              登录
            </div>
          </el-form>
        </div>
      </div>
    </div>


    <alert ref="alert" title="提示" :content="text" @confirm="() => { alertShow = false }"
      @cancel="() => { alertShow = false }" :showCancelButton="false" v-if="alertShow" />

    <vue-zzq-keyboard ref="keyboard" hand float :blurHide="true" size="mini"></vue-zzq-keyboard>
  </div>
</template>

<script>
import { getCurrentUser } from '@/utils/auth'
export default {
  data() {
    return {
      activeNav: 0,
      navList: [
        '个人登录',
        '法人登录'
      ],


      loginForm: {
        loginNo: "", // 账号
        password: "", // 密码
        vcode: "", // 验证码
        smscode: "",// 手机验证码
      },
      rules: {
        loginNo: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        vcode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        smscode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      /**
       * 控制密码显示状态的标志
       */
      passwordOpen: false, // 密码是否显示

      btnLoading: false, // 按钮加载

      codeUrl: "",
      vcodeId: "",

      loginMode: 0,

      waitTime: 0,
      codeLoading: false,

      alertShow: false,

      text: ""
    }
  },
  /**
   * 计算属性
   */
  computed: {
    /**
     * 登录按钮是否启用的计算属性
     * @returns {boolean} 返回登录按钮是否应启用
     */
    isLoginBtnEnabled() {
      if (this.loginMode == 0) {
        return (
          this.loginForm.loginNo &&
          this.loginForm.vcode &&
          this.loginForm.smscode
        );
      } else {
        return (
          this.loginForm.loginNo &&
          this.loginForm.password &&
          this.loginForm.vcode
        );
      }
    },
  },
  mounted() {
    // this.handleSpeak('请先登录')

    let audio = new Audio(require('@/assets/audio/login.mp3'));
    audio.play();

    let that = this
    let _qt = window.parent.qt
    if (typeof _qt !== "undefined") {

      // alert(JSON.stringify(_qt));
      new QWebChannel(_qt.webChannelTransport, function (channel) {
        // 通过 channel 访问 Qt 对象
        window.webTransport = channel.objects.webTransport

        // 绑定注册对象的信号
        webTransport.msgToJs.connect(function (msg) {
          msg = JSON.parse(msg)
          that.outputMsg(msg);
        });


        // 调用Qt对象函数
        webTransport.startReader();
      });
    } else {
      // alert("初始化qwebchannel失败");
    }
    this.getCode();
  },
  methods: {
    handleClose() {
      this.ding()
      this.$store.loginShow = false
    },
    handleNav(i) {
      this.activeNav = i
      this.$set(this, 'loginForm', {
        loginNo: "", // 账号
        password: "", // 密码
        vcode: "", // 验证码
        smscode: "",// 手机验证码
      })
    },
    handleMode(i) {
      this.loginMode = i
      this.$set(this, 'loginForm', {
        loginNo: "", // 账号
        password: "", // 密码
        vcode: "", // 验证码
        smscode: "",// 手机验证码
      })
    },

    getCode() {
      this.vcodeId = new Date().getTime();

      // let api = "/loginApi"
      // let url = api + "/gsp/uc90001";

      /** 地市 -- 保德 */
      let url = "/auth/sxzwAuth/uc90009V2"

      /** 地市 -- 其他 */
      // let url = "https://www.sxzwfw.gov.cn/service/gsp/uc90001";

      // let url = "https://www.sxzwfw.gov.cn/authService/gsp/uc90009";

      let data = {
        /** 地市 -- 保德 */
        txnBodyCom: {
          vcodeId: this.vcodeId,
        }
        // /** 地市 -- 其他 */
        // vcodeId: this.vcodeId,
      };

      /** 地市 -- 保德 */
      this.$api.manage.postAction(url, data).then((res) => {
      /** 地市 -- 其他 */
      // this.$api.manage.getActionBlob(url, data).then(async (res) => {

        console.log("【验证码】", res);
        // this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        // if (this.captchaEnabled) {

        /** 地市 -- 其他 */
        // const href = window.URL.createObjectURL(res); //转成url格式
        // this.codeUrl = href; //赋值
        /** 地市 -- 保德 */
        this.codeUrl = res.msg; //赋值

        // this.codeUrl = res['C-Response-Body'].data; //赋值
        // this.loginForm.uuid = res.uuid;
        // }
      });
    },
    /**
     * 登录操作
     */
    login() {
      let that = this
      // if (!this.isLoginBtnEnabled) {
      //     this.$message.error('存在未填充信息，请检查');
      //     return
      // }
      this.$refs.loginForm.validate((valid) => {
        this.btnLoading = true;
        if (valid) {
          if (this.loginMode == 1) {
            let data = {
              ...this.loginForm,
              usertype: this.activeNav == 0 ? '10' : '20',
              vcodeId: this.vcodeId,
            };
            that.$store
              .dispatch("Login", data)
              .then((res) => {
                console.log("【登录】", res);

                // this.refreshCode();
                that.$store.isLogin = true
                that.$store.userInfo = getCurrentUser()
                console.log("【个人信息】", that.$store.userInfo);
                that.btnLoading = false;
                that.show = false
                that.$emit("loginSuccess")
              })
              .catch((err) => {
                if (err.code == 501 || err.code == 502) {
                  that.text = err.code == 501 ? '当前账号未注册，请到山西政务网进行注册。' : err.msg
                  that.alertShow = true
                  that.btnLoading = false;
                  that.getCode();
                } else {
                  console.log("【登录】", err);
                  that.btnLoading = false;
                  that.$message.error(err);
                  // if (this.captchaEnabled) {
                  that.getCode();
                  // }
                }
              });
          } else if (this.loginMode == 0) {
            let data = {
              username: this.loginForm.loginNo,
              userType: this.activeNav == 0 ? '10' : '20',
              smscode: this.loginForm.smscode
            };
            that.$store
              .dispatch("LoginByPhone", data)
              .then((res) => {
                console.log("【登录】", res);
                // this.refreshCode();
                that.$store.isLogin = true
                that.$store.userInfo = getCurrentUser()
                that.btnLoading = false;
                that.show = false
                that.$emit("loginSuccess")
              })
              .catch((err) => {
                if (err.code == 501 || err.code == 502) {
                  that.text = err.code == 501 ? '当前账号未注册，请到山西政务网进行注册。' : err.msg
                  that.alertShow = true
                  that.btnLoading = false;
                  that.getCode();
                } else {
                  console.log("【登录】", err);
                  that.btnLoading = false;
                  that.$message.error(err);
                  // if (this.captchaEnabled) {
                  that.getCode();
                  // }
                }
              });
          }
        } else {
          console.log("error submit!!");
          this.btnLoading = false;
          return false;
        }
      });
    },

    // 短信验证码
    handleCode() {
      if (!this.loginForm.loginNo) {
        this.$message.error('请输入手机号');
        return
      }

      /** 地市 -- 保德(暂时废弃) */
      // let url = "http://59.195.207.70:19086/service/gsp/uc00001"
      /** 地市 -- 其他 */
      let url = "/auth/sxzwAuth/sendCodeV2"

      let data = {
        txnCommCom: {},
        txnBodyCom: {
          userMobile: this.loginForm.loginNo,
          vcodeId: this.vcodeId,
          vcode: this.loginForm.vcode,
          validateCodeType: "22"
        }
      }
      this.codeLoading = true
      this.$api.manage.postAction(url, data).then(res => {
        console.log("【发送验证码】", res)
        this.codeLoading = false
        if (res.code == 200) {
          this.$message.success("验证码已发送")
          this.setWait()
        } else {
          that.text = err.msg
          that.alertShow = true
          that.codeLoading = false;
          this.getCode();
        }
      }).catch((err) => {
        console.log(err)
        this.codeLoading = false
        this.$message.error(err.msg)
      })
    },

    setWait() {
      let that = this
      this.waitTime = 120;
      let timer = setInterval(function () {
        if (that.waitTime > 0) {
          that.waitTime = that.waitTime - 1;
        } else {
          clearInterval(timer);
        }
      }, 1000);
    },

    outputMsg(msg) {
      if (this.loginForm.loginNo != msg.ID) {
        if (this.loginMode == 0) {
          this.$set(this, 'loginMode', 1)
        }
        this.$set(this.loginForm, 'loginNo', msg.ID)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_mask {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding-top: 136px;
  background: rgba(0, 0, 0, 0.5);

  .close {
    position: absolute;
    top: -68px;
    right: 1px;
    width: 48px;
    height: 48px;
  }

  .login_dia {
    position: relative;
    display: flex;
    width: 1420px;
    height: 808px;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px 0px rgba(212, 212, 212, 0.25);
    border-radius: 16px 16px 16px 16px;

    &_left {
      position: relative;
      width: 730px;
      height: 100%;
      padding: 10px;
      padding-right: 0;

      img {
        width: 100%;
        height: 100%;
      }

      .title_box {
        position: absolute;
        top: 57px;
        left: 55px;
        display: flex;

        &_left {
          width: 65px;
          height: 90px;
          margin-right: 14px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        &_right {
          h4 {
            margin-bottom: 4px;
            font-weight: 600;
            font-size: 32px;
            color: #000000;
            line-height: 45px;
            text-align: left;
          }

          p {
            font-weight: 400;
            font-size: 26px;
            color: #000000;
            line-height: 36px;
            text-align: left;
          }
        }
      }
    }

    &_right {
      flex: 1;

      &_nav {
        display: flex;


        &_item {
          width: 380px;
          height: 71px;
          background-image: url(@/assets/images/tab_click2.png);
          background-size: 100% 100%;
          font-weight: 500;
          font-size: 28px;
          color: #78828F;
          line-height: 71px;

          &.active {
            background-image: url(@/assets/images/tab_click.png);
          }

          &:last-child {
            margin-left: -70px;
            background-image: url(@/assets/images/tab_img.png);

            &.active {
              background-image: url(@/assets/images/tab_img2.png);
            }
          }
        }

        .active {
          z-index: 30;
          color: #3F87FF;
        }
      }

      &_form_content {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 46px;

        .item {
          cursor: pointer;
          padding: 0 29px;
          border-right: 2px solid #E2E2E2;
          font-weight: 500;
          font-size: 22px;
          color: #888888;
          line-height: 26px;

          &:last-child {
            border-right: none;
          }
        }

        .activeTab {
          color: #3F87FF;
        }
      }

      &_form {
        padding: 37px 105px 0 85px;
        text-align: left;

        .login_password {
          img {
            vertical-align: middle;
            width: 26px;
            height: 26px;
          }
        }

        .input_img {
          vertical-align: middle;
          width: 26px;
          height: 26px;
          margin-left: 12px;
        }

        .btn {
          width: 500px;
          height: 66px;
          margin-top: 60px;
          background: #3F87FF;
          box-shadow: 0px 6px 0px 0px #1964E0;
          border-radius: 16px 16px 16px 16px;
          font-weight: 600;
          font-size: 26px;
          color: #FFFFFF;
          line-height: 66px;
          text-align: center;
        }

        .btn.disabled {
          background: #E6E6E6;
          box-shadow: 0px 6px 0px 0px #DCDCDC;
          color: #ADADAD;
        }

        .vcode {
          width: 140px;
          height: 44px;
          margin-top: 7px;
          margin-right: -16px;
          background: #3F87FF;
          border-radius: 8px 8px 8px 8px;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 44px;
          text-align: center;
        }

        .vcode.disabled {
          background: #E0E5EB;
          color: #B7BFCD;
        }

        ::v-deep .el-form {
          .el-form-item__label {
            font-family: PingFangSC;
            font-weight: 400;
            font-size: 20px;
            color: #666666;
            line-height: 28px;

            &::before {
              display: none;
            }
          }

          .el-input__inner {
            height: 58px;
            padding-left: 58px;
            background: #F5F7FA;
            border-radius: 10px 10px 10px 10px;
            border: none;
            font-family: PingFangSC;
            font-weight: 400;
            font-size: 20px;
            line-height: 58px;
          }

          .el-form-item__content {
            line-height: 58px;
          }

          .el-input__suffix {
            padding-right: 20px;
          }

          .is-error {
            .el-input__inner {
              background: #FFF5F5;
              border: 1px solid #FF2E2E;
            }

            .el-form-item__error {
              font-family: PingFangSC;
              font-weight: 400;
              font-size: 18px;
              color: #FF2E2E;
              line-height: 23px;
              top: -40px;
              right: 0;
              left: auto;
            }
          }
        }
      }
    }
  }
}
</style>